import { FETCH_STCK_SO_PAYMENT_LIST, RECEIVE_STCK_SO_PAYMENT_LIST, FAILED_STCK_SO_PAYMENT_LIST } from '../../actions/stocker/stck.sopayment.act'

const defaultStckSoPaymentState = {
    stckSoPaymentData: [],
    stckTotalSoPayment: 0,
    stckSoPaymentSelect: [],
    success: true,
    inProgress: false,
}

export function StckSoPayment(state = defaultStckSoPaymentState, action){
    switch (action.type) {
        case FETCH_STCK_SO_PAYMENT_LIST:
            return ({stckSoPaymentData: [], success: true, stckTotalSoPayment: 0, stckSoPaymentSelect: [], inProgress: true})
        case RECEIVE_STCK_SO_PAYMENT_LIST:
            var _totalSoPayment = action.payload.result.length;
            var _stckSoPaymentSelect = []
            // if(action.payload.result !== []) {
            //     var _poApprovalData = action.payload.result

            //     _poApprovalData.forEach((p, index) => {
            //         var _loc = {
            //             'label': _poApprovalData[index].po_type_name + ' (' + _poApprovalData[index].po_type_desc + ')',
            //             'value': _poApprovalData[index].id,"id": 1,
            //             "id_company": 1,
            //             "id_purchase_order": 1,
            //             "po_number": "PO0001",
            //             "po_creation_date": "2021-10-15 21:00:00",
            //             "po_due_date": "2021-12-15 21:00:00",
            //             "id_po_rule": 1,
            //             "limit_po_value": 10,
            //             "step_count": 10,
            //             "id_user_approval": 122,
            //             "id_division": 1,
            //             "division_name": "",
            //             "remark": ""
            //         }
            //         _stckSoPaymentSelect.push(_loc)
            //     })
            // }
            return Object.assign({}, state, {stckSoPaymentData: action.payload, success: true, stckTotalSoPayment: _totalSoPayment, stckSoPaymentSelect: _stckSoPaymentSelect, inProgress: false})
        case FAILED_STCK_SO_PAYMENT_LIST:
            return ({stckSoPaymentData: [], success: false, stckTotalSoPayment: 0, stckSoPaymentSelect: [], inProgress: false})
        default:
            return state
    }
}